import store from '@/store'
import config from '@/config'
import lib from '@/library'

export default {
  data () {
    return {
      setUserActiveFromCasinoIframeGame: true // this is for casino game launcher to prevent multiple calls on each post message received from the game.

    }
  },
  computed: {
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    sessionDetails () {
      return store.getters['getSessionDetails']
    },
    customerContext () {
      return store.getters['getCustomerContext']
    },
    lastLogin () {
      if (this.customerContext && this.customerContext.Logins && this.customerContext.Logins[1]) {
        return new Date(this.customerContext.Logins[1]).toLocaleString(this.dateFormats.locale, {timeZone: config.app.timeZone})
      } else {
        return '--'
      }
    },
    dateFormats () {
      return config.app.dateFormats
    },
    isFirstEverLogin () {
      return this.customerContext &&
             this.customerContext.Logins &&
             this.customerContext.Logins.length === 1
    },
    loginTime () {
      return store.getters['getLoginTime'] || Date.now()
    }
  },

  methods: {
    userIsActive () {
      if (this.isLoggedIn) {
        lib.rpcService.api.helpers.stopTokenTImer()
        store.commit('setUserActive', true)
      }
    },
    userIsActiveInCasinoActiveGame () {
      if (!this.setUserActiveFromCasinoIframeGame) return false
      this.setUserActiveFromCasinoIframeGame = false
      setTimeout(() => {
        if (this.isLoggedIn) {
          lib.rpcService.api.helpers.stopTokenTImer()
          store.commit('setUserActive', true)
          this.setUserActiveFromCasinoIframeGame = true
        }
      }, 10000)
    }
  },

  created () {

  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Session.js